export default {
  sessions: state => state.sessions,
  session: state => state.session,
  answers: state => state.answers,
  questions: state => state.questions,
  currentQuestion: state => state.currentQuestion,
  isCanFinish: state => state.isCanFinish,
  errors: state => state.errors
};
